import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import React, {Suspense, useMemo} from 'react'

import BranchSelect from '../../../../../containers/BranchFilter'
import {useBranch} from '../../../../../hooks/routes'
import Routes, {getHref} from '../../../../../routes'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs'
import {getPipelineBreadcrunbs} from '../../components/common/Breadcrumbs/Breadcrumbs.utils'
import Description from '../../components/common/Description/Description'
import PipelineEditButton from '../../components/common/PipelineEditButton/PipelineEditButton'
import RunButton from '../../components/common/RunButton/RunButton'
import headerStyles from '../../EditPipelinePage/EditPipelineHeader/EditPipelineHeader.css'
import type {pipelineHeadFragment$key} from '../../hooks/__generated__/pipelineHeadFragment.graphql'
import {usePipelineHeadId, usePipelineId} from '../../hooks/pipeline'
import usePipelineDocumentTitle from '../../hooks/usePipelineDocumentTitle'
import {pipelinesApi} from '../../services/pipelinesApi'

import styles from './PipelineHeader.css'

type Props = {pipelineHeadKey: pipelineHeadFragment$key | null}
export default function PipelineHeader({pipelineHeadKey}: Props) {
  const id = usePipelineId()
  const {name, description} = pipelinesApi.endpoints.getPipelineById.useQuery(id, {
    selectFromResult: ({data}) => {
      const {settings, vcsRoot} = data ?? {}
      return {
        name: settings?.name,
        description: vcsRoot?.url,
      }
    },
  })
  const headId = usePipelineHeadId(pipelineHeadKey)
  const branch = useBranch()

  usePipelineDocumentTitle(name)
  const branchSelect = useMemo(
    () => (
      <BranchSelect
        className={styles.branchSelectButton}
        projectOrBuildTypeNode={{nodeType: 'bt', id: headId!}}
      />
    ),
    [headId],
  )

  return (
    <div className={styles.header}>
      <div className={styles.breadcrumbs}>
        {name != null && <Breadcrumbs path={getPipelineBreadcrunbs(id, name)} />}
      </div>
      <div className={styles.heading}>
        <H1 className={styles.title}>{name}</H1>
        {description != null && (
          <Description className={headerStyles.description} text={description} />
        )}
        {branchSelect}
      </div>
      <div className={styles.actions}>
        <Suspense>
          <PipelineEditButton to={getHref(Routes.EDIT_PIPELINE, {id})} />
        </Suspense>
        <RunButton
          primary
          headId={headId!}
          className={styles.button}
          branchName={branch?.default ? undefined : branch?.name}
        />
      </div>
    </div>
  )
}
